export default __webpack_public_path__ + "static/heroselfridges-c52c0bba55bf24203579f52569238956.jpg";